<template>
  <div class="p-information">
    <v-img src="/images/banner/information.png" :height="bannerHeight">
      <v-layout
        fill-height
        align-center
        justify-center
        column
        class="light-text"
      >
        <h1>易才宏业保险经纪有限公司</h1>
        <h2 class="mt-4">互联网保险信息披露</h2>
      </v-layout>
    </v-img>
    <div class="section">
      <v-tabs
          class="navigation"
          centered
          center-active>
          <v-tab 
            v-for="(item,index) in navigationList"
            :key="index"
            @click="choose(index)"
            class="item_tab"
            :class="chooseId===index?'pitchLi':''">{{item}}</v-tab>   
      </v-tabs>
    </div>
    
    <!-- <section class="section">
        <ul class="navigation">
          <li
          v-for="(item,index) in navigationList"
          :key="index"
          @click="choose(index)"
          :class="chooseId===index?'pitchLi':''"
          >
            {{item}}
          </li>
        </ul>
    </section> -->

    <div v-show="chooseId===0">
      <section class="section">
        <h2 class="mb-4">公司经营资质</h2>
        <v-layout justify-center wrap>
          <v-flex xs12 sm12 md6>
            <v-img
              max-height="400px"
              contain
              src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-insurance-licence.jpg"
            ></v-img>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-img
              max-height="400px"
              contain
              src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-business-license.png"
            ></v-img>
          </v-flex>
        </v-layout>
      </section>
      <section class="section">
        <h2 class="mb-4">互联网保险自营平台信息</h2>
        <v-data-table
          :headers="supportHeaders"
          :items="supportItems"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">{{ props.item.company }}</td>
          </template>
        </v-data-table>
      </section>
      <section class="section">
        <h2 class="mb-4">各地分公司联系方式</h2>
        <v-data-table
          :headers="informationHeaders"
          :items="informationItems"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">{{ props.item.company }}</td>
            <td class="td-text tb-row-caption">
              <div
                v-if="typeof props.item.no === 'string'"
                v-html="props.item.no"
              ></div>
              <div v-else>
                <div v-for="item in props.item.no" :key="item">{{ item }}</div>
              </div>
            </td>
          </template>
        </v-data-table>
      </section>

      <section class="section">
        <h2 class="mb-4">客户告知书</h2>
        <div class="contact">
          <v-img
            src="/images/information/khgzs.png"
            contain
          ></v-img>
        </div>
      </section>

      <section class="section">
        <h2 class="mb-4">信息安全</h2>
        <div class="contact">
          <p class="contact-email">针对消费者的个人信息、投保交易信息和交易安全，已进行加密传输，严保传输过程中信息不被泄露。并开启安全管理系统权限设置，防止资料被无权限获取</p>
        </div>
      </section>

      <section class="section">
        <h2 class="mb-4">从业人员执业登记信息查询</h2>
        <div class="contact">
          <p>
            <a href="http://iir.circ.gov.cn/" target="_blank" rel="noopener noreferrer">http://iir.circ.gov.cn/</a>
          </p>
        </div>
      </section>

      

      <section class="section">
        <h2 class="mb-4">客户服务及投诉渠道</h2>
        <div class="contact">
          <p>投保、理赔、保全服务及投诉电话：4006-234-345</p>
          <p class="contact-email">投诉邮箱：tousu@chinatalentgroup.com</p>
          <v-img
            max-height="200px"
            contain
            src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/kfwx.png"
          ></v-img>
        </div>
      </section>
    </div>

    <div v-show="chooseId===1">
      <section class="section a_section">
        <h2 class="mb-4">互联网保险产品信息</h2>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">
              <div>
                <div v-for="item in props.item.company" :key="item">
                  {{item}}
                </div>
              </div>
              
            </td>
            <td class="td-text">
              <div>
                <div v-for="item in props.item.serial_num" :key="item">
                  {{item}}
                </div>
              </div>
            </td>
            <td class="td-text tb-row-caption">
              <div>
                <div v-for="item in props.item.terms" :key="item">
                  <a
                    :href="item.url"
                    style="color: #222; text-decoration: underline"
                    >《{{ item.name }}》</a
                  >
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
      </section>
    </div>
    <div v-show="chooseId===2">
      <section class="section b_section">
        <h2 class="mb-4">合作保险公司</h2>
        <v-data-table
          dense
          :headers="productHeaders"
          :items="productItems"
          hide-actions
          class="table"
        > 
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text ">{{ props.item.branch }}</td>

            <td class="td-text tb-row-caption">
              {{ props.item.no }}


            </td>
            <td class="td-text tb-row-caption">
              {{ props.item.time }}
            </td>
            <td class="td-text">

              <a :href="props.item.company" target="_blank">{{props.item.company}}</a>
            </td>
            <td class="td-text">{{ props.item.tel }}</td>
            <td class="td-text">{{ props.item.flow }}</td>
            <td class="td-text">
              <a :href="props.item.evaluate" target="_blank">{{props.item.evaluate}}</a>
              </td>
          </template>
        </v-data-table>
      </section>
    </div>


  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "信息披露"
  },
  data() {
    return {
      loading: false,
      supportHeaders: [
        { text: "", value: "name", sortable: false },
        { text: "", value: "company", sortable: false }
      ],
      chooseId:0,
      navigationList:['经营资质页','保险产品信息披露页','合作保险公司及机构披露页'],
      supportItems: [
        {
          name: "披露机构全称",
          company: "易才宏业保险经纪有限公司"
        },
        {
          name: "披露机构简称",
          company: "易才保险经纪"
        },
        {
          name: "经营互联网保险业务的网站名称",
          company: "易才保险经纪"
        },
        {
          name: "经营互联网保险业务的网站地址",
          company: "https://www.dhjyib.com/"
        },
        {
          name: "经营互联网保险业务的APP名称",
          company: "企惠保"
        },
        {
          name: "经营互联网保险业务的微信公众号名称",
          company: "企惠保；集光易保"
        },
        {
          name: "客户服务及消费者投诉电话",
          company: "4006-234-345"
        },
        {
          name: "机构信息披露网站地址",
          company: "https://www.dhjyib.com/information"
        }
      ],
      informationHeaders: [
        { text: "名称", value: "name", sortable: false },
        { text: "电话", value: "company", sortable: false },
        { text: "地址", value: "no", sortable: false }
      ],
      informationItems: [
        {
          name: "易才宏业保险经纪有限公司",
          company: "022-88325599",
          no: "天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408"
        },
        {
          name: "易才宏业保险经纪有限公司北京分公司",
          company: "010-50947000",
          no: "北京市朝阳区广渠路东路唐家村43幢一层28-B"
        },
        {
          name: "易才宏业保险经纪有限公司陕西分公司",
          company: "029-87360693",
          no: "陕西省西安市雁塔区融鑫路1号203室"
        },
        {
          name: "易才宏业保险经纪有限公司新疆分公司",
          company: "0991-8822023",
          no: "新疆省乌鲁木齐市天山区光明路100号金碧华府1503室"
        },
        {
          name: "易才宏业保险经纪有限公司甘肃分公司",
          company: "0931-8187101",
          no: "甘肃省兰州市城关区闵家桥100号一楼049室"
        },
        {
          name: "易才宏业保险经纪有限公司河北分公司",
          company: "0311-82956750",
          no: "河北石家庄循环化工园区丘头镇十炼路北行50米北方物流招待中心4层"
        },
        {
          name: "易才宏业保险经纪有限公司吉林分公司",
          company: "",
          no: "长春市二道区东盛大街与荣光路交汇力旺·东玺台写字楼15栋703室"
        },
        {
          name: "易才宏业保险经纪有限公司沧州分公司",
          company: "",
          no: "河北省沧州高新区河北工业大学科技园4号楼2层209号房间"
        }
      ],
      headers: [
        { text: "产品名称", value: "name", sortable: false },
        { text: "备案产品名称", value: "no", sortable: false },
        { text: "备案编号", value: "serial_num", sortable: false },
        { text: "产品条款", value: "terms", sortable: false },
      ],
      items: [
        {
          name: "百年百医保定期医疗保险",
          company: ["《百年百医保定期医疗保险条款》"],
          serial_num:["百年人寿[2020]医疗保险005号"],
          terms:[
            {
              "name": "百年百医保定期医疗保险条款",
              "url": "https://yxfile.aeonlife.com.cn/doc/2020/03/20200314/1/5325/5325_1_1_20200314174529727.pdf"
            },
            {
              "name": "费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/baiyibaoflb.pdf"
            }
          ]
        },
        {
          name: "华夏玉如意年金保险",
          company: ["《华夏玉如意（旗舰版）年金保险》"],
          serial_num:["华夏人寿[2019]年金保险065号","华夏人寿[2018]医疗保险082号","华夏人寿[2018]医疗保险083号","华夏人寿[2019]终身寿险066号"],
          terms:[
            {
              "name": "【主险条款】华夏玉如意（旗舰版）年金保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry1.pdf"
            },
            {
              "name": "【附加险条款】附加质子重离子医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry2.pdf"
            },
            {
              "name": "【附加险条款】华夏金葵花终身寿险（万能型）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry3.pdf"
            },
            {
              "name": "【附加险条款】医保通（普惠版）医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry4.pdf"
            },
            {
              "name": "【费率表】华夏玉如意（旗舰版）年金保险基本保险金额表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry5.pdf"
            },
            {
              "name": "费率表】华夏金葵花终身寿险（万能型）年风险保险费费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/yry6.pdf"
            },
          ]
        },
        {
          name: "史带少儿护齿保(2020)",
          company: ["个人意外身故保险（2019）条款","附加学生幼儿走失保险（2019 版）条款","附加公共场所个人责任保险（2018）条款","附加意外伤害医疗扩展保险（2019 版）条款"],
          serial_num:["C00002332312020010810541","C00002330922018062105321","(史带财险)(备-医疗保险)【2020】(附)086号","(史带财险)(备-其他)【2020】(附)091号"],
          terms:[
            {
              "name": "史带财产保险股份有限公司个人意外身故保险（2019）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hcb1.pdf"
            },
            {
              "name": "史带财产保险股份有限公司附加学生幼儿走失保险（2019版）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hcb2.pdf"
            },
            {
              "name": "史带财产保险股份有限公司附加公共场所个人责任保险（2018）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hcb3.pdf"
            },
            {
              "name": "史带财产保险股份有限公司附加意外伤害医疗扩展保险（2019版）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hcb4.pdf"
            },
            
          ]
        },
        {
          name: "乐游全球境外旅行保险",
          company: ["史带“乐游全球”境外旅行保障计划2017版"],
          serial_num:["C00002332312017041100221"],
          terms: [
            {
              "name": "史带“乐游全球”境外旅行保障计划2017版适用条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1026/1026.pdf"
            }
          ]
        },
        {
          name: "境内户外运动保险",
          company: ["史带境内户外运动保障计划2017版"],
          serial_num:["C00002332312017041100221"],
          terms: [
            {
              "name": "爱自由-境内旅行保障计划3代适用条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1027/1027.pdf"
            }
          ]
        },
        {
          name: "赛事安心境内高风险运动保险",
          company: ["史带赛事安心境内高风险运动计划2017版"],
          serial_num:["C00002332312017041100221"],
          terms: [
            {
              "name": "史带“赛事安心”境内高风险运动计划2017版适用条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1029/1029.pdf"
            }
          ]
        },
        {
          name: "爱自由境内旅游保险",
          company: ["爱自由-境内旅游保障计划3代"],
          serial_num:["C00002332312017041100221"],
          terms: [
            {
              "name": "爱自由-境内旅行保障计划3代适用条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1027/1027.pdf"
            }
          ]
        },
        {
          name: "安全保",
          company: ["平安个人综合（2018）意外伤害保险"],
          serial_num:["平保健发〔2018〕98号"],
          terms: [
            {
              "name": "平安个人综合（2018）意外伤害保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/anquanbao1.pdf"
            },
            {
              "name": "安全保费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/anquanbao2.pdf"
            },
          ]
        },
        {
          name: "平安宝贝（北京版）",
          company: ["平安宝贝少儿高端医疗保险"],
          serial_num:["平保健发〔2021〕82号"],
          terms: [
            {
              "name": "平安宝贝少儿高端医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/bjpinganbaobei2.pdf"
            },
            {
              "name": "平安宝贝北京版费率",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/bjpinganbaobei.pdf"
            },
          ]
        },
        {
          name: "平安宝贝（上海版）",
          company: ["平安宝贝少儿高端医疗保险"],
          serial_num:["平保健发〔2021〕82号"],
          terms: [
            {
              "name": "平安宝贝少儿高端医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/shpinganbaobei.pdf"
            },
            {
              "name": "平安宝贝上海版费率",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/shpinganbaobei2.pdf"
            },
          ]
        },
        {
          name: "e生宝贝（计划一）",
          company: ["平安少儿门急诊医疗保险"],
          serial_num:["平保健发〔2021〕82号"],
          terms: [
            {
              "name": "平安少儿门急诊医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/eshengbaobei1.pdf"
            },
            {
              "name": "平安健康保险股份有限公司平安少儿门急诊医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/eshengbaobei2.pdf"
            },
          ]
        },
        {
          name: "e生宝贝（计划二、三）",
          company: ["平安少儿门急诊医疗保险"],
          serial_num:["平保健发〔2021〕82号"],
          terms: [
            {
              "name": "平安少儿门急诊医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/eshengbaobei1.pdf"
            },
            {
              "name": "平安健康保险股份有限公司平安少儿门急诊医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/eshengbaobei2.pdf"
            },
          ]
        },
        {
          name: "e生保·长期医疗（费率可调）",
          company: ["平安e生保长期个人住院医疗保险（费率可调）"],
          serial_num:["平保健发〔2020〕235号"],
          terms: [
            {
              "name": "平安e生保长期个人住院医疗保险（费率可调）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzy1.pdf"
            },
            {
              "name": "平安健康保险股份有限公司平安e生保长期个人住院医疗保险（费率可调）费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbfl.pdf"
            },
          ]
        },
        {
          name: "终身防癌险",
          company: ["平安质子重离子医疗保险条款","平安长期个人癌症医疗保险（费率可调）条款"],
          serial_num:["平保健发〔2021〕83号","平保健发〔2020〕235号"],
          terms: [
            {
              "name": "平安质子重离子医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/faxtk2.pdf"
            },
            {
              "name": "平安长期个人癌症医疗保险（费率可调）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/faxtk.pdf"
            },
            {
              "name": "平安健康保险股份有限公司平安长期个人癌症医疗保险（费率可调）费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/faxfl.pdf"
            },
          ]
        },
        {
          name: "e生保·长期医疗保险产品组合（线上门诊版）",
          company: ["平安e生保长期个人住院医疗保险（费率可调）","平安特定药品费用医疗保险条款（可加购）","平安质子重离子医疗保险条款（可加购）","平安特定疾病特需医疗保险条款（可加购）"],
          serial_num:["平保健发〔2020〕235号","平保健发〔2021〕83号"],
          terms: [
            {
              "name": "平安e生保长期个人住院医疗保险（费率可调）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh1.pdf"
            },
            {
              "name": "平安特定药品费用医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh2.pdf"
            },
            {
              "name": "平安特定药品费用医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh3.pdf"
            },
            {
              "name": "平安质子重离子医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh4.pdf"
            },
            {
              "name": "平安特定疾病特需医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh5.pdf"
            },
            {
              "name": "平安特定疾病特需医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbzh6.pdf"
            },
          ]
        },
        {
          name: "抗癌卫士2020",
          company: ["平安抗癌卫士个人医疗保险"],
          serial_num:["平保健发〔2021〕85号"],
          terms: [
            {
              "name": "平安抗癌卫士个人医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/kaws1.pdf"
            },
            {
              "name": "平安特定恶性肿瘤药品费用医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/kaws2.pdf"
            },
            {
              "name": "平安附加质子重离子医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/kaws3.pdf"
            },
            {
              "name": "抗癌卫士2020 费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/kaws4.pdf"
            },
          ]
        },
        {
          name: "平安e生保·全家福",
          company: ["平安全家福住院医疗保险"],
          serial_num:["平保健发〔2021〕84号"],
          terms: [
            {
              "name": "平安特定疾病特需医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf1.pdf"
            },
            {
              "name": "平安特定药品费用医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf2.pdf"
            },
            {
              "name": "平安全家福住院医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf3.pdf"
            },
            {
              "name": "平安超额给付医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf4.pdf"
            },
            {
              "name": "平安特定疾病特需医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf5.pdf"
            },
            {
              "name": "平安特定药品费用医疗保险费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/esbqjf6.pdf"
            },
          ]
        },
        {
          name: "易才华农集光癌症百万医疗险",
          company: ["华农财产保险股份有限公司癌症医疗保险条款","华农财产保险股份有限公司","附加恶性肿瘤特定药品费用补偿医疗保险条款","华农财产保险股份有限公司附加扩展质子重离子医疗费用保险条款"],
          serial_num:["C00010132512021042953912","C00010132522021042953942","C00010132522021042953962"],
          terms: [
            {
              "name": "华农财产保险股份有限公司癌症医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ychnjg/hn1.docx"
            },
            {
              "name": "华农财产保险股份有限公司附加恶性肿瘤特定药品费用补偿医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ychnjg/hn2.docx"
            },
            {
              "name": "华农财产保险股份有限公司附加扩展质子重离子医疗费用保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ychnjg/hn3.docx"
            }
          ]
        },
        {
          name: "复星联合康乐一生（2021版）重大疾病保险",
          company: ["复星联合康乐一生（2021版）重大疾病保险条款","复星联合附加投保人豁免保险费重大疾病保险（2021款）条款"],
          serial_num:["复星联合健康保险〔2020〕疾病保险041号"],
          terms: [
            {
              "name": "复星联合附加投保人豁免保险费重大疾病保险（2021款）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/klys1.pdf"
            },
            {
              "name": "复星联合附加投保人豁免保险费重大疾病保险（2021款）费率现价",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/klys2.pdf"
            }
          ]
        },
        {
          name: "复星联合超越保2020医疗保险",
          company: ["复星联合超越保 2020 医疗保险条款"],
          serial_num:["复星联合健康保险〔2020〕医疗保险017号"],
          terms: [
            {
              "name": "复星联合超越保 2020 医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/cyb1.pdf"
            },
            {
              "name": "复星联合超越保 2020 医疗保险-计划一费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/cyb2.pdf"
            },
            {
              "name": "复星联合超越保 2020 医疗保险-计划二费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/cyb3.pdf"
            },
          ]
        },
        {
          name: "复星联合妈咪保贝（新生版）少儿重大疾病保险",
          company: ["复星联合附加投保人豁免保险费重大疾病保险（2021款）","复星联合妈咪保贝（新生版）少儿重大疾病保险条款"],
          serial_num:["复星联合健康保险〔2021〕疾病保险006号","复星联合健康保险〔2020〕疾病保险041号"],
          terms: [
            {
              "name": "复星联合妈咪保贝（新生版）少儿重大疾病保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/mmbb1.pdf"
            },
            {
              "name": "复星联合附加投保人豁免保险费重大疾病保险（2021款）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/fxlh/mmbb2.pdf"
            },
          ]
        },
        {
          name: "易才阳光集光防癌险",
          company: ["阳光财产保险股份有限公司个人癌症医疗保险条款","阳光财产保险股份有限公司附加扩展质子重离子医疗费用保险B款条款","阳光财产保险股份有限公司附加特定恶性肿瘤院外药品费用医疗保险条款","阳光财产保险股份有限公司附加恶性肿瘤海外医疗保险B款条款"],
          serial_num:["C00009332512021041946641","C00009332522019101817562","C00009332522019101817552","C00009332522019101817572"],
          terms: [
            {
              "name": "阳光财产保险股份有限公司个人癌症医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ycygfax/1.pdf"
            },
            {
              "name": "阳光财产保险股份有限公司附加扩展质子重离子医疗费用保险B款条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ycygfax/2.pdf"
            },
            {
              "name": "阳光财产保险股份有限公司附加特定恶性肿瘤院外药品费用医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ycygfax/3.pdf"
            },
            {
              "name": "阳光财产保险股份有限公司附加恶性肿瘤海外医疗保险B款条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ycygfax/4.pdf"
            },
            {
              "name": "阳光守护-防癌保费率表",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ycygfax/5.pdf"
            },
          ]
        },
        {
          name: "平安集光意外保险",
          company: ["中国平安财产保险股份有限公司平安意外伤害保险（B款）条款"],
          serial_num:["C00001732312020112608632"],
          terms: [
            {
              "name": "中国平安财产保险股份有限公司平安意外伤害保险（B款）条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/pajgywx/1.pdf"
            }
          ]
        },
        {
          name: "京东安联臻爱无限医疗保险2021版-个人版基本计划（含可选保障适用）",
          company: ["个人人身意外伤害保险条款（2020）版","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021通用版）","附加质子重离子医疗保险条款（2021版）","附加住院前后门急诊医疗费用补偿保险条款（2021版）","附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）","附加100种重疾每日住院津贴保险条款（2021版）","附加个人6种重疾给付保险条款（2021版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020041600181","C00005032522020042607181","C00005032522020050804771","C00005032522020031316351","C00005032622020102600071","C00005032622020102600081"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/1.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2020通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/2.pdf"
            },
            {
              "name": "附加质子重离子医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/3.pdf"
            },
            {
              "name": "附加住院前后门急诊医疗费用补偿保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/4.pdf"
            },
            {
              "name": "附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/5.pdf"
            },
            {
              "name": "附加100种重疾每日住院津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/6.pdf"
            },
            {
              "name": "附加个人6种重疾给付保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx1/7.pdf"
            },
          ]
        },
        {
          name: "京东安联臻爱无限医疗保险2021版--个人版卓越计划（含可选保障适用）",
          company: ["个人人身意外伤害保险条款（2020）版","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021版特需）","附加质子重离子医疗保险条款（2021版）","附加住院前后门急诊医疗费用补偿保险条款（2021版）","附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）","附加100种重疾每日住院津贴保险条款（2021版）","附加个人6种重疾给付保险条款（2021版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020041600151","C00005032522020042607181","C00005032522020050804771","C00005032522020031316351","C00005032622020102600071","C00005032622020102600081"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/1.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021版特需）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/2.pdf"
            },
            {
              "name": "附加质子重离子医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/3.pdf"
            },
            {
              "name": "附加住院前后门急诊医疗费用补偿保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/4.pdf"
            },
            {
              "name": "附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/5.pdf"
            },
            {
              "name": "附加100种重疾每日住院津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/6.pdf"
            },
            {
              "name": "附加个人6种重疾给付保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx2/7.pdf"
            }
          ]
        },
        {
          name: "京东安联臻爱无限2021版家庭版--家庭版基本计划（含可选保障适用）",
          company: ["个人人身意外伤害保险条款（2020）版","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021通用版）","附加质子重离子医疗保险条款（2021版）","附加住院前后门急诊医疗费用补偿保险条款（2021版）","附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）","附加100种重疾每日住院津贴保险条款（2021版）","附加个人6种重疾给付保险条款（2021版）","附加家庭保单共享免赔额保险条款（2021通用版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020041600181","C00005032522020042607181","C00005032522020050804771","C00005032522020031316351","C00005032622020102600071","C00005032622020102600081","C00005032522020041600131"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/1.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/2.pdf"
            },
            {
              "name": "附加质子重离子医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/3.pdf"
            },
            {
              "name": "附加住院前后门急诊医疗费用补偿保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/4.pdf"
            },
            {
              "name": "附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/5.pdf"
            },
            {
              "name": "附加100种重疾每日住院津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/6.pdf"
            },
            {
              "name": "附加个人6种重疾给付保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/7.pdf"
            },
            {
              "name": "附加家庭保单共享免赔额保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx3/8.pdf"
            }
          ]
        },
        {
          name: "京东安联臻爱无限2021版家庭版--家庭版卓越计划（含可选保障适用）",
          company: ["个人人身意外伤害保险条款（2020）版","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021版特需）","附加质子重离子医疗保险条款（2021版）","附加住院前后门急诊医疗费用补偿保险条款（2021版）","附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）","附加100种重疾每日住院津贴保险条款（2021版）","附加个人6种重疾给付保险条款（2021版）","附加家庭保单共享免赔额保险条款（2021通用版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020041600151","C00005032522020042607181","C00005032522020050804771","C00005032522020031316351","C00005032622020102600071","C00005032622020102600081","C00005032522020041600131"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/1.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（2021版特需）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/2.pdf"
            },
            {
              "name": "附加质子重离子医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/3.pdf"
            },
            {
              "name": "附加住院前后门急诊医疗费用补偿保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/4.pdf"
            },
            {
              "name": "附加个人特定恶性肿瘤赴德治疗医疗保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/5.pdf"
            },
            {
              "name": "附加100种重疾每日住院津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/6.pdf"
            },
            {
              "name": "附加个人6种重疾给付保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/7.pdf"
            },
            {
              "name": "附加家庭保单共享免赔额保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzawx4/8.pdf"
            }
          ]
        },
        {
          name: "京东安联京彩一生百万医疗保险",
          company: ["个人人身意外伤害保险条款（2020）版","附加恶性肿瘤医疗费用补偿保险条款（2021通用版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020042607171"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcys/1.pdf"
            },
            {
              "name": "附加恶性肿瘤医疗费用补偿保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcys/1.pdf"
            }
          ]
        },
        {
          name: "京东安联住院宝保障计划(2019版)",
          company: ["个人人身意外伤害保险条款（2020）版","附加疾病住院医疗费用补偿保险条款（2020通用版）","意外伤害保险附加人身意外伤害医疗费用补偿保险条款"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032522020042002401","C00005032322019120301572"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzyb/1.pdf"
            },
            {
              "name": "附加疾病住院医疗费用补偿保险条款（2020通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzyb/1.pdf"
            },
            {
              "name": "意外伤害保险附加人身意外伤害医疗费用补偿保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzyb/1.pdf"
            }
          ]
        },
        {
          name: "小幸孕 - 京东安联母婴保障计划",
          company: ["个人人身意外伤害保险条款（2020）版","附加妊娠疾病津贴保险条款（2021版）","附加妊娠难产津贴保险条款（2021版）","意外伤害保险附加意外终止妊娠慰问津贴保险条款（2021版）","附加新生儿先天性畸形疾病津贴保险条款（2021通用版）","附加新生儿先天性畸形疾病手术费用补偿保险条款（2021通用版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032622020042001881","C00005032622020042801591","C00005032522020022906241","C00005032522020022906211","C00005032622020042001811","C00005032522020041600281"],
          terms: [
            {
              "name": "个人人身意外伤害保险条款（2020）版",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/1.pdf"
            },
            
            {
              "name": "附加妊娠疾病津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/2.pdf"
            },
            {
              "name": "附加妊娠难产津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/3.pdf"
            },
            {
              "name": "意外伤害保险附加意外终止妊娠慰问津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/4.pdf"
            },
            {
              "name": "附加新生儿先天性畸形疾病津贴保险条款（2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/5.pdf"
            },
            {
              "name": "附加新生儿先天性畸形疾病手术费用补偿保险条款（B款2021版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdxxy/6.pdf"
            }

          ]
        },
        {
          name: "京东安联臻心医疗保险",
          company: ["个人高端医疗保险条款（2021通用版）"],
          serial_num:["C00005032512020041600251"],
          terms: [
            {
              "name": "个人高端医疗保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdzx/1.pdf"
            },
            
          ]
        },
        {
          name: "成长优享-高端儿童医疗保险（2021版）",
          company: ["未成年人门急诊医疗保险条款（2020通用版）","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（扩展私立版）"],
          serial_num:["C00005032512020120213431","C00005032522020111102561"],
          terms: [
            {
              "name": "未成年人门急诊医疗保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdczyx/1.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（扩展私立版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdczyx/1.pdf"
            }
          ]
        },
        {
          name: "成长优享-高端儿童医疗保险（2021北京版）",
          company: ["未成年人门急诊医疗保险条款（2020通用版）","附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（扩展私立版）"],
          serial_num:["C00005032512020120213431","C00005032522020111102561"],
          terms: [
            {
              "name": "未成年人门急诊医疗保险条款（2021通用版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdczyx/2.pdf"
            },
            {
              "name": "附加个人住院和特定重大疾病特殊门诊医疗费用补偿保险条款（扩展私立版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdczyx/2.pdf"
            }
          ]
        },
        {
          name: "京东安联京彩一家共享保额意外险",
          company: ["京东安联财产保险有限公司团体人身意外伤害保险条款（2020版）","京东安联财产保险有限公司团体人身意外伤害附加意外伤害医疗费用补偿保险条款（A款2019版）","京东安联财产保险有限公司团体人身意外伤害附加意外每日住院津贴保险条款B款（2019版）","京东安联财产保险有限公司团体人身意外伤害附加救护车费用保险条款（2020版）","京东安联财产保险有限公司团体人身意外伤害附加猝死保险条款（2019版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 091号","(京东安联)(备-普通意外保险)【2020】(附) 296号","(京东安联)(备-普通意外保险)【2020】(附) 024号","(京东安联)(备-普通意外保险)【2020】(附) 545号","(京东安联)(备-普通意外保险)【2020】(附) 027号"],
          terms: [
            {
              "name": "京东安联财产保险有限公司团体人身意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcyj/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司团体人身意外伤害附加意外伤害医疗费用补偿保险条款（A 款 2019 版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcyj/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司团体人身意外伤害附加意外每日住院津贴保险条款B款（2019版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcyj/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司团体人身意外伤害附加救护车费用保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcyj/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司团体人身意外伤害附加猝死保险条款（2019版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdjcyj/1.pdf"
            },
          ]
        },
        {
          name: "京东安联全民综合意外保障计划",
          company: ["京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）","京东安联财产保险有限公司意外伤害保险附加公共交通工具意外伤害保险条款（2020版）","京东安联财产保险有限公司附加自驾意外伤害保险条款（2020版）","京东安联财产保险有限公司附加猝死保险条款（2019版）","京东安联财产保险有限公司意外伤害保险附加人身意外伤害医疗费用补偿保险条款（2020版）","京东安联财产保险有限公司意外伤害保险附加意外每日住院津贴保险条款（2020版）","京东安联财产保险有限公司附加公共场所个人责任保险条款（2020版）"],
          serial_num:["C00005032312019120301562","C00005032322019120302092","C00005032322020040817562","C00005032322019111100812","C00005032322019120301572","C00005032322019120301582","C00005032322019120301542"],
          terms: [
            {
              "name": "京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司意外伤害保险附加公共交通工具意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司附加自驾意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司附加猝死保险条款（2019版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司意外伤害保险附加人身意外伤害医疗费用补偿保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司意外伤害保险附加意外每日住院津贴保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司附加公共场所个人责任保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdqmzh/1.pdf"
            },
          ]
        },
        {
          name: "京东安联百万玫瑰意外保障计划",
          company: ["京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）","京东安联财产保险有限公司意外伤害保险附加人身意外伤害医疗费用补偿保险条款（2020版）"],
          serial_num:["C00005032312019120301562","C00005032322019120301572"],
          terms: [
            {
              "name": "京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdbwmg/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司意外伤害保险附加人身意外伤害医疗费用补偿保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdbwmg/1.pdf"
            }
          ]
        },
        {
          name: "不倒翁（新版） - 京东安联中老年人意外骨折保障计划",
          company: ["京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）","京东安联财产保险有限公司意外伤害保险附加骨折保险条款（2020版）","京东安联财产保险有限公司附加意外骨折住院津贴保险条款（2019版）"],
          serial_num:["(京东安联)(备-普通意外保险)【2020】(主) 007号","C00005032322020022605871","C00005032322019122407472"],
          terms: [
            {
              "name": "京东安联财产保险有限公司个人人身意外伤害保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdbdw/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司意外伤害保险附加骨折保险条款（2020版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdbdw/1.pdf"
            },
            {
              "name": "京东安联财产保险有限公司附加意外骨折住院津贴保险条款（2019版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jdbdw/1.pdf"
            },
          ]
        },
        {
          name: "建设工程投标保证保险",
          company: ["投标履约保证保险B款条款（2019版）","富德财产保险股份有限公司建设工程投标保证保险条款","华农财产保险股份有限公司建设工程施工合同投标保证保险条款"],
          serial_num:["C00009331412019020120642","C00016331412017081104371","C00010131412019121304461"],
          terms: [
            {
              "name": "投标履约保证保险B款条款（2019版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/1.pdf"
            },
            {
              "name": "阳光财产保险股份有限公司建设工程投标保证保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/2.pdf"
            },
            {
              "name": "华农财产保险股份有限公司建设工程施工合同投标保证保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/3.pdf"
            }
          ]
        },
        {
          name: "辽宁省公共资源交易网投标保证项目",
          company: ["投标保证保险（2016版）"],
          serial_num:["中国太平洋财产保险股份有限公司投标保证保险 (2016版) 条款","C00001431412016121300822"],
          terms: [
            {
              "name": "投标保证保险（2016版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lntb/1.pdf"
            }
          ]
        },
        {
          name: "建设工程施工合同履约保证保险",
          company: ["华农财产保险股份有限公司建设工程施工合同履约保证保险条款（2017版）"],
          serial_num:["（华农财险）（审－保证）〔2018〕（主）"],
          terms: [
            {
              "name": "华农财产保险股份有限公司建设工程施工合同履约保证保险条款（2017版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sglybzx/1.pdf"
            }
          ]
        },
        {
          name: "美亚“宝贝无忧”儿童意外伤害保险",
          company: ["美亚个人意外伤害保险（2019 年第一版）","美亚附加个人意外医药补偿医疗保险 （2019 年第三版）","美亚附加不承保特定地区医院条款","美亚附加特定国家或地区责任免除条款","美亚附加医院扩展条款（2020年第一版）"],
          serial_num:["C00003932312019032636732","C00003932522019071204762","C00003932322019041002592","C00003932322019041002602","C00003932322020122800302"],
          terms: [
            {
              "name": "美亚个人意外伤害保险（2019 年第一版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/mybbwy/1.pdf"
            },
            {
              "name": "美亚附加个人意外医药补偿医疗保险（2019 年第三版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/mybbwy/2.pdf"
            },
            {
              "name": "美亚附加不承保特定地区医院条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/mybbwy/3.pdf"
            },
            {
              "name": "美亚附加特定国家或地区责任免除条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/mybbwy/4.pdf"
            },
            {
              "name": "美亚附加医院扩展条款（2020年第一版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/mybbwy/5.pdf"
            },
          ]
        },
        {
          name: "北京普惠健康保",
          company: ["中国人寿财产保险股份有限公司北京市医保补充医疗保险条款"],
          serial_num:["C0001083251202107230538"],
          terms: [
            {
              "name": "中国人寿财产保险股份有限公司北京市医保补充医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/bjphjkb/jkb.pdf"
            }
          ]
        },
        {
          name: "成长无忧",
          company: ["法定传染病疾病保险条款","附加学生、幼儿疾病身故保险条款（2010版）","阳光财险附加学生、幼儿意外伤害医疗保险条款","阳光财险附加学生、幼儿住院医疗保险条款","学生、幼儿意外伤害保险条款"],
          serial_num:["(阳光财险)(备-疾病保险)[2021](主)038号","(阳光财险)(备-健康)[2011]（附）3号","(阳光财险)(备-医疗保险)[2019]（附）179号","(阳光财险)(备-医疗保险)[2019]（附）177号","(阳光财险)(备-普通意外保险)[2019]（主）041号 "],
          terms: [
            {
              "name": "法定传染病疾病保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/1.pdf"
            },
            {
              "name": "附加学生、幼儿疾病身故保险条款（2010版）",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/2.pdf"
            },
            {
              "name": "学生、幼儿意外伤害保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/3.pdf"
            },
            {
              "name": "阳光财险附加学生、幼儿意外伤害医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/4.pdf"
            },
            {
              "name": "阳光财险附加学生、幼儿住院医疗保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/5.pdf"
            },
          ]
        },
        {
          name: "复星联合学生平安保险",
          company: ["复星联合学生平安意外伤害保险条款","复星联合附加学生住院医疗保险条款"],
          serial_num:["复星联合健康保险（2020）意外伤害保险 018 号","复星联合健康保险〔2021〕医疗保险 020 号"],
          terms: [
            {
              "name": "复星联合学生平安意外伤害保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/fxlh1.pdf"
            },
            {
              "name": "复星联合学生平安意外伤害保险条款",
              "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xuepingx/fxlh1.pdf"
            }
          ]
        },
        // {
        //   name: "小微企业保",
        //   company: ["财产一切险； 公众责任保险；","平安产险意外伤害保险（C款）","平安产险交通工具意外伤害保险","平安法定节假日驾乘意外伤害保险","平安法定传染病身故保险","灭火费用扩展条款A；清理残骸费用扩展条款","企财险附加险-施救费用条款","企财险附加险-放弃比例分摊扩展条款"," 突发公共卫生事件导致的营业中断损失保险","平安公众责任保险附加广告招牌及装饰物责任保险","平安公众责任保险附加罢工；暴动；民众骚乱及恶意破坏责任保险","平安公众责任保险附加急救费用保险","平安公众责任保险附加诉讼费用保险；","平安公众责任保险附加有缺陷的卫生设施责任保险","火灾和爆炸责任条款；","食品；饮料责任条款","平安产险附加意外伤害住院津贴保险；","平安产险附加意外伤害医疗费用补偿保险","平安意外险附加突发疾病身故保险"],
        //   serial_num:["平安财险（备-企财）[2011]主19号","(平安财险)(备-责任保险)【2020】(主) 300号","(平安财险)(备-普通意外保险)【2020】(主) 330号","(平安财险)(备-普通意外保险)【2020】(主) 143号","(平安财险)(备-普通意外保险)【2020】(主) 043号","(平安财险)(备-其他)【2020】(主) 170号","平安财险（备-企财）[2012]附358号","平安财险（备-企财）[2012]附362号","平安财险（备-企财）[2015]附118号","平安财险（备-企财）[2013]附139号","(平安财险)(备-企财险)【2020】(附) 1008号","(平安财险)(备-责任保险)【2020】(附) 130号 ","(平安财险)(备-责任保险)【2020】(附) 297号","(平安财险)(备-责任保险)【2020】(附) 136号","(平安财险)(备-责任保险)【2020】(附) 530号","(平安财险)(备-责任保险)【2020】(附) 140号 ","(平安财险)(备-普通意外保险)【2020】(附) 1011号"],
        //   terms: [
        //     {
        //       "name": "财产一切险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw1.pdf"
        //     },
        //     {
        //       "name": "中国平安财产保险股份有限公司平安产险附加意外伤害医疗费用补偿保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw2.pdf"
        //     },
        //     {
        //       "name": "中国平安财产保险股份有限公司平安产险附加意外伤害住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw3.pdf"
        //     },
        //     {
        //       "name": "平安产险交通工具意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw4.pdf"
        //     },
        //     {
        //       "name": "平安产险意外伤害保险（C 款）条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw5.pdf"
        //     },
        //     {
        //       "name": "平安法定节假日驾驶人意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw6.pdf"
        //     },
        //     {
        //       "name": "平安附加广告招牌及装饰物责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw7.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加罢工、暴动、民众骚乱及恶意破坏责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw8.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加急救费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw9.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加食品、饮料责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw10.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加诉讼费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw11.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加有缺陷的卫生设施责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw12.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw13.pdf"
        //     },
        //     {
        //       "name": "平安企财险附加突发公共卫生事件导致的营业中断损失保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw14.pdf"
        //     },
        //     {
        //       "name": "平安意外险附加突发疾病身故保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw15.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-放弃比例分摊扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw16.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-灭火费用扩展条款 A",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw17.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-清理残骸费用扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw18.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-施救费用条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xwqyb/xw19.pdf"
        //     },

        //   ]
        // },
        // {
        //   name: "乐享360",
        //   company: ["财产综合险；企财险附加水箱","水暖管爆裂扩展；灭火费用扩展条款A","清理残骸费用扩展条款","企财险附加险-盗窃险扩展条款","突发公共卫生事件导致的营业中断损失保险","公众责任保险；提供酒精饮品责任条款","平安公众责任保险附加广告招牌及装饰物责任保险","平安公众责任保险附加急救费用保险","客人财产责任条款；火灾和爆炸责任条款","平安产险意外伤害保险（C款）","平安产险附加意外伤害医疗费用补偿保险"],
        //   serial_num:["平安财险（备-企财）[2011]主18号","平安财险（备-企财）[2014]附101号","平安财险（备-企财）[2012]附358号","平安财险（备-企财）[2012]附362号","平安财险（备-企财）[2012]附362号","平安财险（备-企财）[2012]附334号","(平安财险)(备-企财险)【2020】(附) 1008号","(平安财险)(备-责任保险)【2020】(主) 300号","(平安财险)(备-责任保险)【2020】(附) 130号","(平安财险)(备-普通意外保险)【2020】(主) 330号","C00001732522021043058702 "],
        //   terms: [
        //     {
        //       "name": "财产综合险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3601.pdf"
        //     },
        //     {
        //       "name": "平安产险附加意外伤害医疗费用补偿保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3602.pdf"
        //     },
        //     {
        //       "name": "平安产险意外伤害保险（C 款）条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3603.pdf"
        //     },
        //     {
        //       "name": "平安附加广告招牌及装饰物责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3604.pdf"
        //     },
        //     {
        //       "name": "平安工程险附加险-火灾和爆炸责任扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3605.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加急救费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3606.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加客人财产责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3607.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加提供酒精饮品责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3608.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx3609.pdf"
        //     },
        //     {
        //       "name": "平安企财险附加突发公共卫生事件导致的营业中断损失保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx36010.pdf"
        //     },
        //     {
        //       "name": "企财险附加水箱、水暖管爆裂扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx36011.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-盗窃险扩展条款A",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx36012.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-灭火费用扩展条款A",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx36013.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-清理残骸费用扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lx360/lx36014.pdf"
        //     },
        //   ]
        // },
        // {
        //   name: "施工宝",
        //   company: ["建工一切险","平安产险建筑工程团体意外伤害保险","交叉责任条款；灭火费用条款A","专业费用特别条款B","平安工程保险附加清除残骸费用保险","公共当局扩展条款A；特别费用扩展条款","平安产险附加意外伤害住院津贴保险"],
        //   serial_num:["平安（备案）[2009]N32号","(平安财险)(备-普通意外保险)【2020】(主) 332号","平安财险（备-工程）[2010]附1887号","(平安财险)(备-工程保险)【2020】(附) 614号","C00001732522021031025262"],
        //   terms: [
        //     {
        //       "name": "建筑工程一切险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb1.pdf"
        //     },
        //     {
        //       "name": "工程保险附加险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb2.pdf"
        //     },
        //     {
        //       "name": "平安财险道路工程险-交叉责任扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb3.pdf"
        //     },
        //     {
        //       "name": "平安财险工程保险附加险-公共当局扩展条款 B",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb4.pdf"
        //     },
        //     {
        //       "name": "平安财险工程保险附加险-专业费用特别条款 B",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb5.pdf"
        //     },
        //     {
        //       "name": "平安产险附加意外伤害住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb6.pdf"
        //     },
        //     {
        //       "name": "平安产险建筑工程团体意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb7.pdf"
        //     },
        //     {
        //       "name": "平安工程保险附加清除残骸费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb8.pdf"
        //     },
        //     {
        //       "name": "企财险附加险-灭火费用扩展条款 A",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sgb/sgb9.pdf"
        //     },
        //   ]
        // },
        // {
        //   name: "装修宝",
        //   company: ["建工一切险；平安产险建筑工程团体意外伤害保险","平安工程保险附加清除残骸费用保险","平安工程保险附加灭火费用保险","交叉责任条款；平安附加猝死保障保险","平安产险附加意外伤害住院津贴保险"],
        //   serial_num:["平安（备案）[2009]N32号","(平安财险)(备-普通意外保险)【2020】(主) 332号","(平安财险)(备-工程保险)【2020】(附) 614号","(平安财险)(备-工程保险)【2020】(附) 628号","(平安财险)(备-其他)【2020】(附) 1030号","C00001732522021031025262 "],
        //   terms: [
        //     {
        //       "name": "建筑工程一切险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb1.pdf"
        //     },
        //     {
        //       "name": "平安财险道路工程险-交叉责任扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb2.pdf"
        //     },
        //     {
        //       "name": "平安产险附加意外伤害住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb3.pdf"
        //     },
        //     {
        //       "name": "平安产险建筑工程团体意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb4.pdf"
        //     },
        //     {
        //       "name": "平安附加猝死保障保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb5.pdf"
        //     },
        //     {
        //       "name": "平安工程保险附加灭火费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb6.pdf"
        //     },
        //     {
        //       "name": "平安工程保险附加清除残骸费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zxb/zxb7.pdf"
        //     },
        //   ]
        // },
        // {
        //   name: "顾客安心保",
        //   company: ["公众责任保险","公众责任保险附加险-(k)游泳池责任条款","平安公众责任保险附加广告招牌及装饰物责任保险","平安附加电梯责任保险","平安公众责任保险附加急救费用保险","平安公众责任保险附加诉讼费用保险","停车场责任条款；展览和促销活动扩展条款","火灾和爆炸责任条款食品；饮料责任条款"],
        //   serial_num:["(平安财险)(备-责任保险)【2020】(主) 300号","(平安财险)(备-责任保险)【2020】(附) 152号","(平安财险)(备-责任保险)【2020】(附) 130号","(平安财险)(备-责任保险)【2020】(附) 772号","(平安财险)(备-责任保险)【2020】(附) 136号","(平安财险)(备-责任保险)【2020】(附) 530号","(平安财险)(备-责任保险)【2020】(主) 197号","(平安财险)(备-责任保险)【2020】(附) 143号","(平安财险)(备-责任保险)【2021】(附) 009号","(平安财险)(备-责任保险)【2020】(附) 146号"],
        //   terms: [
        //     {
        //       "name": "平安公众责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb1.pdf"
        //     },
        //     {
        //       "name": "平安工程险附加险-火灾和爆炸责任扩展条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb2.pdf"
        //     },
        //     {
        //       "name": "平安附加电梯责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb3.pdf"
        //     },
        //     {
        //       "name": "平安附加广告招牌及装饰物责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb4.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加急救费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb5.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加食品、饮料责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb6.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加诉讼费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb7.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加停车场责任保险（A 款）条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb8.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加游泳池责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb7.pdf"
        //     },
        //     {
        //       "name": "平安公众责任保险附加展览和促销活动责任保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gkaxb/axb8.pdf"
        //     },
        //   ]
        // },
        // {
        //   name: "爱心人寿心相随年金保险",
        //   company: ["爱心人寿心相随年金保险"],
        //   serial_num:["爱保发[2017]61号"],
        //   terms: [
        //     {
        //       "name": "爱心人寿保险股份有限公司 爱心人寿心相随年金保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/axrsxxs.pdf"
        //     },
        //   ]
        // },
        // {
        //   name: "珠峰·个人意外伤害保险",
        //   company: "珠峰财产保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "珠峰财产保险股份有限公司个人意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1086/1086-1.pdf"
        //     },
        //     {
        //       "name": "珠峰财产保险股份有限公司附加意外伤害医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1086/1086-2.pdf"
        //     },
        //     {
        //       "name": "珠峰财产保险股份有限公司个人意外伤害保险附加意外伤害住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1086/1086-3.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url":"https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zhufengflb.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "华保健康医疗险",
        //   company: "华农财险保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "华农财产保险股份有限公司个人医疗费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hb1.pdf"
        //     },
        //     {
        //       "name":"华农财产保险股份有限公司附加扩展质子重离子医疗费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hb2.pdf"
        //     },
        //     {
        //       "name":"华农财产保险股份有限公司附加癌症特定药品费用补偿医疗保险条款",
        //       "url":"https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hb3.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/huabaoflb.xlsx"
        //     }
        //   ]
        // },
        // {
        //   name: "企业员工团体补充医疗保险",
        //   company: "泰康在线财产保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "泰康在线团体交通工具人身意外伤害保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/1.pdf"
        //     },
        //     {
        //       "name": "团体门（急）诊医疗保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/2.pdf"
        //     },
        //     {
        //       "name": "团体人身意外伤害保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/3.pdf"
        //     },
        //     {
        //       "name": "团体重大疾病保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/4.pdf"
        //     },
        //     {
        //       "name": "团体住院津贴医疗保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/5.pdf"
        //     },
        //     {
        //       "name": "团体住院医疗保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1074/6.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "平安·安诊无忧·百万医疗",
        //   company: "中国平安保险（集团）股份有限公司",
        //   terms:[
        //     {
        //       "name": "平安医疗费用保险（D款）条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1087/1087-1.pdf"
        //     },
        //     {
        //       "name": "平安附加医疗健康管理服务保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1087/1087-2.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "平安·E生平安·防癌宝",
        //   no: "C00001732512020022401102",
        //   company: "中国平安保险（集团）股份有限公司",
        //   terms:[
        //     {
        //       "name": "平安重大疾病保险（白金版）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1083/1083-1.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "平安·E生平安·百万医",
        //   company: "中国平安保险（集团）股份有限公司",
        //   terms:[
        //     {
        //       "name": "平安意外伤害医疗和疾病医疗保险（平安e生保2020款）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1080/1080-1.pdf"
        //     },
        //     {
        //       "name": "平安附加海外特定医疗保险（亚洲版）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1080/1080-2.pdf"
        //     },
        //     {
        //       "name": "平安恶性肿瘤国际会诊医疗保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1080/1080-3.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "平安·E生平安·重疾险",
        //   company: "中国平安保险（集团）股份有限公司",
        //   terms:[
        //     {
        //       "name": "平安重大疾病保险（白金版）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1081/1081-1.pdf"
        //     },
        //     {
        //       "name": "平安附加重症监护室治疗保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1081/1081-2.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "平安驾乘人员意外保险",
        //   company: "中国平安保险（集团）股份有限公司",
        //   terms:[
        //     {
        //       "name": "平安驾乘人员意外伤害保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1082/1082-1.pdf"
        //     },
        //     {
        //       "name": "平安法定节假日驾乘人员个人意外伤害保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1082/1082-2.pdf"
        //     },
        //     {
        //       "name": "平安个人法律费用补偿保险",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1082/1082-3.pdf"
        //     }
        //   ]
        // },
        
        // {
        //   name: "复工综合保险方案",
        //   company: "珠峰财产保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "珠峰财产保险股份有限公司财产基本险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zf1.pdf"
        //     },
        //     {
        //       "name": "珠峰财产保险股份有限公司附加传染病营业中断保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zf2.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/zhufengflb.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "儿童综合意外",
        //   company: "众安在线财产保险股份有限公司",
        //   terms: [
        //     {
        //       "name": "众安在线财产保险股份有限公司个人意外伤害保险条款(2017版)",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/0.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司附加意外伤害医疗费用保险条款（B款）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/1.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司附加个人责任保险条款（B款）",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/2.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司个人白血病疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/3.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司未成年人重大疾病及疾病身故保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/4.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司附加学生手足口病医疗费用补偿保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/5.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司附加中暑医疗费用保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/6.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司个人住院医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/7.pdf"
        //     },
        //     {
        //       "name": "众安在线财产保险股份有限公司个人住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/8.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1036/tk/feilvbiao.pdf"
        //     }
        //   ],
        // },

        // {
        //   name: "常青藤老年防癌疾病保险",
        //   company: "华夏人寿保险股份有限公司",
        //   terms: [
        //     {
        //       "name": "华夏常青藤老年防癌疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1011/1011.pdf"
        //     },
        //     {
        //       "name": "华夏常青藤防癌医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1011/1011-1.pdf"
        //     },
        //     {
        //       "name": "附加质子重离子医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1011/1011-2.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/huaxiafeilvbiao.xlsx"
        //     }
        //   ]
        // },
        // {
        //   name: "珍爱宝贝少儿年金保险",
        //   company: "华夏人寿保险股份有限公司",
        //   terms: [
        //     {
        //       "name": "华夏珍爱宝贝少儿年金保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1012/1012.pdf"
        //     },
        //     {
        //       "name": "医保通（普惠版）医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1012/1012-1.pdf"
        //     },
        //     {
        //       "name": "附加质子重离子医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1012/1012-2.pdf"
        //     },
        //     {
        //       "name": "节节高养老年金保险（万能型）条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1012/1012-3.pdf"
        //     },
        //     {
        //       "name": "节节高养老年金保险（万能型）产品说明书",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1012/1012-4.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/huaxiafeilvbiao.xlsx"
        //     }
        //   ]
        // },
        // {
        //   name: "鑫爱e家终身寿险",
        //   company: "华贵人寿",
        //   terms:[
        //     {
        //       "name":"鑫爱e家终身寿险条款",
        //       "url":"https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/xinaietiaokuan.pdf"
        //     }
        //   ]
        // },
        
        // {
        //   name: "复星联合倍吉星重大疾病保险",
        //   company: "复星联合健康保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "复星联合倍吉星重大疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1077/1077.pdf"
        //     },
        //     {
        //       "name": "复星联合附加投保人豁免保险费重大疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1077/1077-1.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/bjxflb.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "妈咪保贝少儿重大疾病保险",
        //   no: "复星联合健康保险（2019）疾病保险005号；<br/>复星联合健康保险（2018）疾病保险064号",
        //   company: "复星联合健康保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "复星联合妈咪保贝少儿重大疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1068/tk/0.pdf"
        //     },
        //     {
        //       "name": "复星联合附加投保人豁免保险费重大疾病保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1068/tk/1.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "孝欣保恶性肿瘤医疗险特惠版",
        //   company: "众安在线财产保险股份有限公司",
        //   terms:[
        //     {
        //       "name": "众安在线财产保险股份有限公司个人恶性肿瘤医疗保险条款(2018 版)",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1035/tk/0.pdf"
        //     },
        //     {
        //       "name": "费率表",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/product/1035/tk/feilvbiao.pdf"
        //     }
        //   ]
        // },
        
        // {
        //   name: "诚泰团体人身意外伤害保险",
        //   company: "诚泰财产保险股份有限公司",
        //   terms: [
        //     {
        //       "name": "团体人身意外伤害保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1001/%E8%AF%9A%E6%B3%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E5%9B%A2%E4%BD%93%E4%BA%BA%E8%BA%AB%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf"
        //     },
        //     {
        //       "name": "附加意外伤害医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1001/%E8%AF%9A%E6%B3%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf"
        //     },
        //     {
        //       "name": "附加意外伤害住院津贴保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1001/%E8%AF%9A%E6%B3%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf"
        //     },
        //     {
        //       "name": "团体人身意外伤害保险附加住院医疗保险条款",
        //       "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1001/%E8%AF%9A%E6%B3%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E5%9B%A2%E4%BD%93%E4%BA%BA%E8%BA%AB%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%E9%99%84%E5%8A%A0%E4%BD%8F%E9%99%A2%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "超倍保重疾险",
        //   company: "百年人寿保险股份有限公司",
        //   terms:[
        //     {
        //       "name":"百年附加投保人豁免保险费重大疾病保险（2018版）",
        //       "url":"https://bnonline.aeonlife.com.cn/bnonlineimg/h5/20200319/onlineins_1_1_20200319174055126.pdf"
        //     },
        //     {
        //       "name":"费率表",
        //       "url":"https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/cbbflb.pdf"
        //     }
        //   ]
        // }
      ],
      productHeaders: [
        { text: "公司名称", value: "name", sortable: false },
        { text: "分支机构", value: "branch", sortable: false, },
        { text: "业务合作范围", value: "no", sortable: false },
        { text: "合作起止时间", value: "time", sortable: false },
        { text: "公司网址", value: "company", sortable: false },
        { text: "客服电话", value: "tel", sortable: false },
        { text: "产品及保单的查询和验真途经/理赔争议处理机制和工作流程", value: "flow", sortable: false },
        { text: "一年来综合偿付能力充足率/风险综合评级/消费者权益保护监督评价", value: "evaluate", sortable: false },
      ],
      productItems: [
        {
          name: "百年人寿保险股份有限公司",
          branch:'湖北、河北、辽宁、北京、河南、黑龙江、安徽、山东、江苏、四川、福建、陕西、内蒙古、吉林、江西、山西、浙江、广东、重庆',
          time:'2018/12/24-2019/12/23延期不限',
          tel:'95542',
          flow:'保险公司官网',
          evaluate:'http://www.aeonlife.com.cn/info/index.shtml',
          no:"提供各类人寿，健康和人身意外伤害保险等产品",
          company: "http://www.aeonlife.com.cn"
        },
        {
          name: "复星联合健康保险股份有限公司",
          branch:'广东省、北京市、上海市、四川省、江苏省',
          time:'2021/2/1-2022/1/31',
          flow:'保险公司官网',
          tel:'400-611-7777',
          evaluate:'http://www.fosun-uhi.com/PublicInformation/BasicInformation/CompanyInformation/',
          no:"提供各类健康寿产品",
          company:"http://www.fosun-uhi.com/"
        },
        {
          name: "华夏人寿保险股份有限公司",
          branch:'北京、河南、江苏、山东、陕西、安徽、内蒙古、湖南、四川、青岛、云南、河北、广东、浙江、上海、苏州、宁波、深圳、天津、无锡、江西、海南、东莞、黑龙江',
          time:'2019/1/1-2021/12/31',
          tel:'95300',
          flow:'保险公司官网',
          evaluate:'http://hxgw.hualife.cc/publish/main/1080/1081/1084/index.html',
          no:"提供各类人寿产品",
          company: 'http://www.ihxlife.com'
        },
        {
          name: "中国平安财产保险股份有限公司",
          branch:'北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、西藏自治区、陕西省、甘肃省、青海省、宁夏回族自治区、新疆维吾尔自治区',
          flow:'保险公司官网',
          time:'2017年8月-始终有效',
          tel:'95511',
          evaluate:'https://property.pingan.com/gongkaixinxipilu/gongsigaikuang.shtml',
          no:"健康和人身意外伤害保险等产品",
          company: "https://property.pingan.com/"
        },
        {
          name: "爱心人寿保险股份有限公司",
          branch:'北京、天津、河北、江苏、广东',
          time:'2020/12/28-2021/12/31',
          flow:'保险公司官网',
          tel:'10109520',
          evaluate:'http://www.aixin-ins.com/gsgk/index.jhtml',
          no:"提供各类人寿，健康和人身意外伤害保险等产品",
          company: "http://www.aixin-ins.com/"
        },
        {
          name: "光大永明人寿保险有限公司",
          branch:'天津、北京、浙江、江苏、上海、广东、重庆、辽宁、河北、山西、四川、深圳、苏州、河南、黑龙江、宁波、湖南、陕西、大连、安徽、湖北、山东、福建',
          flow:'保险公司官网',
          time:'2020/7/1-2023/6/31',
          tel:'95348',
          evaluate:'https://www.sunlife-everbright.com/sleb/info/jbxx/gsgk/index.html		',
          no:"提供各类人寿产品",
          company: "https://www.sunlife-everbright.com/"
        },
        {
          name: "泰康在线财产保险股份有限公司",
          branch:'在中华人民共和国境内（港、澳、台地区除外）开展经营范围内的业务。',
          time:'2019/6/26-2021/6/25',
          flow:'保险公司官网',
          tel:'95522',
          evaluate:'http://www.tk.cn/zxpublicinfo/',
          no:"健康和人身意外伤害保险等产品",
          company: "http://www.tk.cn/"
        },
        {
          name: "华农财险保险股份有限公司",
          branch:'北京、江苏、四川、河北、河南、浙江、广西、山西、甘肃、广东',
          flow:'保险公司官网',
          time:'2020/3/17-2021/12/31',
          tel:'400-010-0000',
          evaluate:'https://www.chinahuanong.com.cn/category/7.html',
          no:"健康和人身意外伤害保险等产品",
          company: "https://www.chinahuanong.com.cn/"
        },
        {
          name: "珠峰财产保险股份有限公司",
          branch:'西藏自治区、北京市、四川省、天津市、河北省',
          flow:'保险公司官网',
          time:'"2019/1/7-长期合作"',
          tel:'10108848',
          evaluate:'https://www.zhufengic.com/xxpl/		',
          no:"健康和人身意外伤害保险等产品",
          company: "https://www.zhufengic.com/"
        },
        {
          name: "众安在线财产保险股份有限公司",
          branch:'在中华人民共和国境内（港、澳、台地区除外）开展与互联网交易直接相关的保险业务，不设分支机构',
          time:'2019/12/31-2022/12/30',
          flow:'保险公司官网',
          tel:'952299',
          evaluate:'https://www.zhongan.com/channel/public/publicInfo2018.html		',
          no:"健康和人身意外伤害保险等产品",
          company: "https://www.zhongan.com/"
        },
        {
          name: "华贵人寿保险股份有限公司",
          branch:'贵州、河北',
          time:'"2019/2/27-2020/2/26延期一年"',
          flow:'保险公司官网',
          tel:'400-684-1888',
          evaluate:'https://www.huaguilife.cn/gkxxpl/index.shtml		',
          no:"提供各类人寿产品，健康和人身意外伤害保险等产品",
          company: "https://www.huaguilife.cn/"
        },
        {
          name: "史带财产保险股份有限公司",
          branch:'上海、北京、江苏、浙江、青岛、安徽、福建、苏州、宁波、广东、重庆',
          flow:'保险公司官网',
          time:'2019/5/6-2020/5/5顺延一年',
          tel:'400-9995-507',
          evaluate:'http://www.starrchina.cn/Information%20Disclosure/		',
          no:"健康和人身意外伤害保险等产品",
          company: "http://www.starrchina.cn"
        },
        {
          name: "诚泰财产保险股份有限公司",
          branch:'云南省、四川省、河南省、山西省、湖南省',
          time:'2019/2/19-2021/2/18顺延一年',
          flow:'保险公司官网',
          tel:'400-6222-888',
          evaluate:'http://www.champion-ic.com/survey/		',
          no:"健康和人身意外伤害保险等产品",
          company: "http://www.champion-ic.com/"
        },

      ]
    };
  },
  computed: {
    bannerHeight() {
      return this.$vuetify.breakpoint.name === "xs" ? 150 : 377;
    }
  },
  methods:{
    choose(index){
      this.chooseId = index
    }
  }
};
</script>

<style lang="scss">

.p-information {
  background-color: #ffffff;
  
  .navigation{
    display: flex;
    color:#666666;
    font-size: 18px;
    border-bottom: 1px solid #E4E4E4;
    justify-content: center;
    align-items: center;
    // li{
    //   padding-bottom:23px ;
    // }
    // li:nth-child(2){
    //   margin: 0 135px 0 181px;
    // }
    .pitchLi{
      color:#DD122B ;
      border-bottom: 4px solid #DD122B;
    }
    .item_tab {
      font-size: 18px;
    }
    .item_tab:nth-child(3){
      margin: 0 135px 0 181px;
    }
  }
  h1,
  h2 {
    font-weight: 400;
  }
  .section {
    max-width: 900px;
    margin: 2em auto 0;
    padding: 15px;
    h2 {
      text-align: center;
      font-size: 36px;
    }
  }
  .a_section{
    max-width: 65%;
  }
  .b_section{
    max-width: 100%;
  }
  .licence-img {
    width: 100%;
    max-width: 400px;
  }
  .insurance-licence-img {
    margin-top: 18px;
  }
  .table {
    table {
      min-width: 700px;
      tr:hover {
        background-color: inherit !important;
      }
    }
    thead {
      background-color: #fff6f7;
      th {
        font-size: 1em;
        font-weight: 600;
        color: #222;
      }
    }
    th,
    td {
      border: 1px solid #dadada;
    }
    .tb-row-caption {
      color: $font-color3;
    }
    .td-text {
      padding: 1.5em 1em;
    }
  }
  .contact {
    text-align: center;
    margin-bottom: 4em;
    p {
      margin: 0.5em 0;
    }
  }
}
@media screen and (max-width: 860px) {
  .p-information{
    .navigation{
      .item_tab {
        font-size: 16px;
      }
      .item_tab:nth-child(3){
        margin: 0 10px 0 10px;
      }
    }
    .mb-4 {
      font-size: 28px!important;
    }
    .a_section{
      max-width: 100%;
    }
    .b_section{
      max-width: 100%;
    }
  }
    
  }
</style>
<style scoped>

</style>
